import { render } from "./GroupReportParametres.vue?vue&type=template&id=a88ae974"
import script from "./GroupReportParametres.vue?vue&type=script&lang=js"
export * from "./GroupReportParametres.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__